/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import { memo } from "react";
import Logo from "../../../app/theme-layouts/shared-components/Logo";
import CircularProgress from "@mui/material/CircularProgress";

function BASESplashScreen() {
  return (
    <div id="base-splash-screen">
      <Logo />
    </div>
  );
}

export default memo(BASESplashScreen);
